export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./noFormat.vue?vue&type=template&id=40a78266&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/noFormat.vue?vue&type=template&id=40a78266&
// module id = 1331
// module chunks = 0